"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Thanks = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../hooks");
var _models = require("../../models");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Thanks = ({
  currentType
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage,
    translations
  } = (0, _hooks.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.THANKS),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconWrap, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckCircle, {
        fontSize: "inherit"
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Header, {
      variant: "h5",
      component: "h5",
      color: "textPrimary",
      children: translations.thankYou
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      textAlign: "center",
      color: "textPrimary",
      children: formatMessage(_models.TranslationKey.notifyMeSuccess, {
        0: currentType === _models.BackInStockNotificationChannel.Email ? translations.email : translations.sms
      })
    })]
  });
};
exports.Thanks = Thanks;
